<div class="container">
    <div class="row justify-content-center mt-5">
        <img class="logo" src="../../../assets/images/logos/logo-museum.png">
    </div>
    <div class="row justify-content-center mt-5" *ngIf="errorMessage">
        <div class="error">
            {{ errorMessage }}
        </div>
    </div>
    <div class="d-flex justify-content-center" *ngIf="isLoading">
        <museum-loader></museum-loader>
    </div>
</div>